import * as React from "react";
import Axios from "./Components/Axios";
import Auth from "./Auth";

class Main extends React.Component{

    componentDidMount() {
        Axios
            .get('api/menu')
            .then(r => {
                console.log(r);
                if(!r.data.length) window.location.href = 'http://megacom.kg';
                if(!!r.data.length) this.props.history.push('/admin/services');
            })
            .catch(() => {});
    }

    render() {
        return '';
    }

}

export default Main;